export class DataFieldType {
    public DateTypeId: number;
    public DataTypeName: string;
    public DataTypeEnum: DataFieldTypes;
}

export enum DataFieldTypes {
    Unknown = "Unknown",
    TextBox = "TextBox",
    CheckBox = "CheckBox",
    DropDown = "DropDown",
    File = "File",
    Password = "Password",
    XmlArtifact = "XmlArtifact",
    AssemblyArtifact = "AssemblyArtifact",
    Array = "Array"
}
